var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      class: _vm.$style.modalWrapper,
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c(
        "v-content",
        { class: _vm.$style.modalContentContainer },
        [
          _c(
            "v-layout",
            {
              class: _vm.$style.modalContent,
              attrs: {
                "align-center": "",
                "justify-center": "",
                column: "",
                "fill-height": ""
              }
            },
            [
              _c("div", { class: _vm.$style.logo }, [_c("Logo")], 1),
              _vm._v(" "),
              _vm.title
                ? _c("h3", { class: _vm.$style.title }, [
                    _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default")
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileSimpleModalContainer.vue?vue&type=template&id=0a6c4230&
// module id = null
// module chunks = 